import { createAction } from '@reduxjs/toolkit';

export const requestRetrieveAccounts = createAction('admin-account/retrieveAccounts');
export const requestFindAccount = createAction('admin-account/findAccount');
export const requestReviewCompanyDocuments = createAction('admin-account/reviewCompanyDocuments');
export const requestUploadCompanyDocument = createAction('admin-account/uploadCompanyDocument');
